import { EmployeeInfo } from "./EmployeeInfo";
import { NotificationsButton } from "./NotificationsButton";
import { PencomBackButton } from "./PencomBackButton";
import { Link, useLocation } from "react-router-dom";
import { PencomRoutes } from "@/router/PencomRoutes";
import { NeedHelpDropdown } from "@/components/common/NeedHelpDropdown";

const PencomHeader = () => {
  const location = useLocation();

  // Show back button on all pages except dashboard
  const showBackButton = location.pathname !== PencomRoutes.DASHBOARD;

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-stroke">
      <div className="flex flex-row items-center justify-between gap-x-8 py-3 px-8 lg:px-[100px]">
        <div className="flex items-center gap-x-6">
          <Link
            to={PencomRoutes.DASHBOARD}
            className="inline-flex items-center"
            aria-label="Go to dashboard home"
          >
            <img
              src="/assets/images/onboarding/pencom_logo_transparent.png"
              alt="PenCom"
              className="h-10 w-auto"
            />
          </Link>
          {showBackButton && <PencomBackButton title="Back" />}
        </div>
        <div className="flex flex-row items-center gap-x-8">
          <div className="flex flex-row items-center gap-x-4">
            <div className="flex flex-row items-center gap-x-2">
              <span className="font-clash-display text-md text-medium-dark-grey">
                Need help?
              </span>
              <Link
                to={PencomRoutes.SUPPORT}
                className="font-clash-display text-md font-semibold text-primary-button underline hover:opacity-90"
              >
                Send a message
              </Link>
            </div>
            <NeedHelpDropdown iconOnly />
          </div>
          <NotificationsButton />
          <EmployeeInfo />
        </div>
      </div>
    </header>
  );
};

export default PencomHeader;
